export default function themePalette(color, mode) {
  return {
    mode: mode,
    common: {
      black: '#000',
      white: '#fff'
    },
    primary: color.primary,
    secondary: color.secondary,
    info: color.info,
    success: color.success,
    warning: color.warning,
    error: color.error,
    neutral: color.neutral,
    divider: color.divider,
    text: color.text,
    background: color.background,
    charts: color.charts,
    action: {
      selectedOpacity: 0.3
    }
  };
}